<template>
  <div class="so-message">
    <base-heading>{{ $t('standingOrder.createOrderTitle') }}</base-heading>
    <div class="message-wrapper">
      <img class="image" src="/assets/images/no-results.svg" alt=""/>
      <h3 class="title">{{ $t('standingOrder.notEligible.title') }}</h3>
      <p class="description">{{ $t('standingOrder.notEligible.description') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'so-not-eligible'
}
</script>

<style scoped lang="scss" src="./styles/so-comps-common.scss"></style>
